import { ThemeContext } from "#/providers/theme-provider";
import Image from "next/image";
import { useContext } from "react";

export function StreamLogo() {
  const theme = useContext(ThemeContext);

  return (
    <div className="relative h-7 w-28">
      <Image
        // The src is whatever brand owns this shell, so the alt text has to
        // follow it. Hardcoding "Stream Logo" announced a partner's own logo
        // as Stream's to every screen reader on a white-label site.
        alt={theme.name ? `${theme.name} logo` : "Logo"}
        className="object-contain"
        fill
        src={theme.imageUrl}
      />
    </div>
  );
}
